import { THEME_DARK, THEME_LIGHT } from "./type";

export const themeDark = () => {
	return {
		type: THEME_DARK,
	};
};

export const themeLight = () => {
	return {
		type: THEME_LIGHT,
	};
};
